import React from 'react';
import './bootcamp.css';
import brain from '../../../../img/bootcamp/brain.png'
import head_light from '../../../../img/bootcamp/head_light.png'
import head_mechanism from '../../../../img/bootcamp/head_mechanism.png'

const b_why = () => {
    const state = {
        why_block: [
            {
                img: head_light,
                title: `Get Prepped`,
                desc: `With Prerequisites training, you can start learning the fundamentals. Learn programming, SQL, and basic math skills.`,
            },
            {
                img: brain,
                title: `1 or 2-day Immersive`,
                desc: `From  June 16th to June 17th, join our 2-day live immersive Mini-Bootcamp. Get hands-on experience in machine learning and deep learning.`,
            },
            {
                img: head_mechanism,
                title: `Continue Learning`,
                desc: `After immersive training, you will be perfectly positioned to continue learning. WIth Ai+ on-demand training and discounted live training, you can learn at your own pace.`,
            },
      ],
    };

    const renderWhyItem = (item, i) => {
        return (
            <div className="b_why--block">
                <img className="b_why--img" src={item.img} alt="" />
                <div className='b_why--text_block'>
                    <h4 className="b_why--title_text">{item.title}</h4>
                    <p className="b_why--desc">{item.desc}</p>
                </div>
            </div>
        );
    };

    return (
        <div className="m_wywl__wrap b_wywl__wrap">
            <div className="m_wywl container">
                <h3 className="b_why--title">WHY GEEKLE BOOTCAMPS?</h3>
                <p className='b_why--undertitle'>BUILD YOUR SKILLS AND BUILD YOUR NETWORK</p>
                <div className="b_why--blocks">
                    {state.why_block.map((item, i) => renderWhyItem(item, i))}
                </div>
            </div>
        </div>
    );
};

export default b_why;